export default "__VITE_ASSET__BpA5GG2c__"